if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");
        this.additionalSubmitAction = this.querySelector(
          "[data-submit-action]"
        );

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";

        if (this.additionalSubmitAction) {
          this.additionalSubmitAction.addEventListener("click", () => {
            this.onAdditionalSubmitAction();
          });
        }
      }

      onAdditionalSubmitAction() {
        this.submitButton.click();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const productId = this.form.querySelector("[name='product-id']");
        if (productId && productId.value === "8894878253281") return;

        let oldAppstleState;
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        if (
          this.submitButton.getAttribute("data-force-disable-appstle") ===
            "true" &&
          document.getElementById("appstle_selling_plan_label_20")
        ) {
          oldAppstleState = document.getElementById(
            "appstle_selling_plan_label_20"
          ).checked;
          document.getElementById(
            "appstle_selling_plan_label_20"
          ).checked = false;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        // Try your original widget first
        let sellingPlanId = "";

        // 1. Check for upsell widget in the form (radio button)
        const checkedPurchaseOption = this.form.querySelector(
          'input[type="radio"][name^="purchaseOption_"]:checked'
        );
        if (
          checkedPurchaseOption &&
          checkedPurchaseOption.dataset.sellingPlanId
        ) {
          sellingPlanId = checkedPurchaseOption.dataset.sellingPlanId;
        }

        // 2. If not found, and NOT an upsell form, check for Loop widget globally
        if (!sellingPlanId && !this.hasAttribute("data-individual-upsell")) {
          console.log('entered this 2nd IF')
          const loopSelected = document.querySelector(
            ".loop-widget-purchase-option.loop-widget-purchase-option-selected"
          );
          if (loopSelected) {
            const loopSelect = loopSelected.querySelector(
              'select.loop-widget-sp-selector[name="selling_plan"]'
            );
            if (loopSelect) {
              sellingPlanId = loopSelect.value;
            }
          }
        }

        const sellingPlanInput = this.form.querySelector(
          'input[name="selling_plan"]'
        );
        if (
          sellingPlanInput &&
          (!this.hasAttribute("data-individual-upsell") || sellingPlanId)
        ) {
          sellingPlanInput.value = sellingPlanId;
        }

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        // only on the cart page, for upsells
        const removeConnectedProduct = this.hasAttribute("data-remove-product");
        const productToRemoveId = this.getAttribute("data-product-remove-id");
        const productToRemoveLine = this.getAttribute(
          "data-product-remove-line"
        );

        const freeSubscriptionProduct = document.querySelector(
          "[data-free-subscription-product]"
        );

        // TODO: make better, not hardcoded
        const isGoodFibes = formData.get("id") == "45790844027105";
        if (
          freeSubscriptionProduct &&
          formData.get("selling_plan") &&
          !removeConnectedProduct &&
          !isGoodFibes
        ) {
          const freeSubscriptionProductId =
            freeSubscriptionProduct.getAttribute(
              "data-free-subscription-product-id"
            );

          formData.append("items[1]id", freeSubscriptionProductId);
          formData.append("items[1]quantity", formData.get("quantity") || 1);
        }

        if (removeConnectedProduct) {
          this.addAndRemove(
            productToRemoveId,
            productToRemoveLine,
            config,
            formData
          );
          return;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");

            if (
              this.submitButton.getAttribute("data-force-disable-appstle") ===
                "true" &&
              document.getElementById("appstle_selling_plan_label_20")
            ) {
              document.getElementById("appstle_selling_plan_label_20").checked =
                oldAppstleState;
            }
          });
      }

      addAndRemove(productToRemoveId, productToRemoveLine, config, formData) {
        const body = JSON.stringify({
          line: productToRemoveLine,
          quantity: "0",
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            fetch(`${routes.cart_add_url}`, config)
              .then((response) => response.json())
              .then((response) => {
                if (response.status) {
                  publish(PUB_SUB_EVENTS.cartError, {
                    source: "product-form",
                    productVariantId: formData.get("id"),
                    errors: response.errors || response.description,
                    message: response.message,
                  });
                  this.handleErrorMessage(response.description);

                  const soldOutMessage =
                    this.submitButton.querySelector(".sold-out-message");
                  if (!soldOutMessage) return;
                  this.submitButton.setAttribute("aria-disabled", true);
                  this.submitButtonText.classList.add("hidden");
                  soldOutMessage.classList.remove("hidden");
                  this.error = true;
                  return;
                } else if (!this.cart) {
                  window.location = window.routes.cart_url;
                  return;
                }

                if (!this.error)
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: "product-form",
                    productVariantId: formData.get("id"),
                    cartData: response,
                  });
                this.error = false;
                const quickAddModal = this.closest("quick-add-modal");
                if (quickAddModal) {
                  document.body.addEventListener(
                    "modalClosed",
                    () => {
                      setTimeout(() => {
                        this.cart.renderContents(response);
                      });
                    },
                    { once: true }
                  );
                  quickAddModal.hide(true);
                } else {
                  this.cart.renderContents(response);
                }
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                this.submitButton.classList.remove("loading");
                if (this.cart && this.cart.classList.contains("is-empty"))
                  this.cart.classList.remove("is-empty");
                if (!this.error)
                  this.submitButton.removeAttribute("aria-disabled");
                this.querySelector(".loading__spinner").classList.add("hidden");

                if (
                  this.submitButton.getAttribute(
                    "data-force-disable-appstle"
                  ) === "true" &&
                  document.getElementById("appstle_selling_plan_label_20")
                ) {
                  document.getElementById(
                    "appstle_selling_plan_label_20"
                  ).checked = oldAppstleState;
                }
              });
          })
          .catch(() => {
            const errors =
              document.getElementById("cart-errors") ||
              document.getElementById("CartDrawer-CartErrors");
            errors.textContent = window.cartStrings.error;
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
